<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <template three-line v-if="cardapio">
        <v-expansion-panel>
            <v-expansion-panel-content v-for="(categoria,catIndex) in cardapio">
            <template v-slot:header>
                <div v-html="categoria.nome"></div>
            </template>
            <v-card>
                <v-card-text class="px-0">
                    <template>
                        <template v-if="categoria.texto">
                          <div class="grey--text text--lighten-1 caption my-0 pt-0 pb-1 pl-4 pr-2" v-html="categoria.texto">"</div>
                        <v-divider></v-divider>
                        </template>
                        <v-list v-for="(item, index) in categoria.produtos">
                        <v-divider v-if="index > 0"></v-divider>
                        <v-list-tile :key="item.id">
                            <v-list-tile-avatar v-if="item.doc.img && item.doc.img.length>0 && item.doc.img[0]!=''" @click="$emit('clique-no-produto',index,catIndex)">
                            <img :src="item.doc.img[0]">
                            </v-list-tile-avatar> 
                            <v-list-tile-content @click="$emit('clique-no-produto',index,catIndex)">
                            <v-list-tile-title v-html="item.nome" class="body-1"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="tiraQuebasDeLinhas(item.descricao)" class="caption"></v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action class="priceAct">
                            <div class="text-xs-center priceLabel" v-if="parseFloat(item.doc.condicao[0].valor)>0">
                                <template v-if="item.doc.valorantigo && parseFloat(item.doc.valorantigo)>0 && parseFloat(item.doc.valorantigo)>parseFloat(item.doc.condicao[0].valor)">
                                  <div class="caption text-decoration-line-through grey--text mt-3">De R$ {{parseFloat(item.doc.valorantigo).toFixed(2).replace('.',',')}}</div>
                                  <div class="caption success--text font-weight-bold">Por R$ {{parseFloat(item.doc.condicao[0].valor).toFixed(2).replace('.',',')}}</div>
                                </template>
                                <div v-else class="caption">R$ {{parseFloat(item.doc.condicao[0].valor).toFixed(2).replace('.',',')}}</div>
                                <v-btn small icon v-if="!item.doc.adicionais.length>0 && (!item.doc.variacao || (item.doc.variacao==false||item.doc.variacao=='false'))"  @click="$emit('clique-no-botao-inserir',{
                                            qtd: 1,
                                            nome: item.nome,
                                            id: item.id,
                                            valor: parseFloat(item.doc.condicao[0].valor),
                                            subtotal: parseFloat(item.doc.condicao[0].valor),
                                            opcionais: null
                                        })">
                                <v-icon>add</v-icon>
                                </v-btn>
                                <v-btn small icon v-else @click="$emit('clique-no-produto',index,catIndex)">
                                <v-icon>add</v-icon>
                                </v-btn>
                            </div>
                            <div class="text-xs-center" v-else>
                              <v-btn small icon @click="$emit('clique-no-produto',index,catIndex)">
                                <v-icon>open_in_new</v-icon>
                              </v-btn>
                            </div>
                            </v-list-tile-action>
                        </v-list-tile>
                        </v-list>
                    </template>
                </v-card-text>
            </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>


                    
        </template>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props:[
    'cardapio'
  ],
  data() {
    return {
      //
    };
  },
  methods:{
    tiraQuebasDeLinhas(text){
      let novo = text.replace("<br>"," ");
      if(novo.indexOf("<br>")==-1){
        return novo.substring(0,99);
      }
      while(novo.indexOf("<br>")>=0){
        novo = novo.replace("<br>"," ")
      }
      return novo.substring(0,99);
    }
  }
};
</script>
<style>
.priceAct{min-width: 79px!important; min-height: 65px!important;}
.priceLabel div{white-space: nowrap;}
</style>